import { viewSelectStyles } from "@insite/content-library/Widgets/ProductList/ProductListViewSelect";
import Grid from "@insite/mobius/Icons/Grid";
import List from "@insite/mobius/Icons/List";
import { css } from "styled-components";

viewSelectStyles.wrapper = {
    css: css`
        display: flex;
        padding-top: 5px;
        padding-right: 15px;
        float: right;
    `,
};

viewSelectStyles.listViewIcon = {
    src: List,
    size: 26,
};

viewSelectStyles.gridViewIcon = {
    src: Grid,
    size: 24,
};

viewSelectStyles.tableViewIcon = {
    css: css`
        display: none;
    `,
};
